import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import firebase from 'firebase';
import firebaseui from 'firebaseui';

// Authentication
const auth = (state = {
    user : null,
    ui: null,
    existing_user: null,
    links: null,
    plans: null,
    connections: null
}, action) => {
    switch (action.type) {
        case 'USER_AUTH_STATE_CHANGED' : return { ...state, user : action.data};
        case 'CREATE_FIREBASE_AUTH_UI' : return state.ui ? state : {...state, ui: new firebaseui.auth.AuthUI(firebase.auth())};
        case 'LINKS_FOUND': return {...state, links: action.data};
        case 'PLANS_FOUND': return {...state, plans: action.data};
        case 'CONNECTIONS_FOUND': return {...state, connections: action.data};
        case 'EXISTING_USER': return {...state, existing_user: action.data};
        default : return state;
    }
}

export default combineReducers({
    routing: routerReducer,
    auth: auth
})


// WEBPACK FOOTER //
// ./src/redux/reducers.js